import {debounce} from 'lodash'
import {useEffect, useState} from 'react'

export const useScroll = () => {
  const [isScrolling, setIsScrolling] = useState(false)

  const setScrolling = debounce(setIsScrolling, 100)

  useEffect(() => {
    const handleScrollEvent = () => {
      if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
        setIsScrolling(true)
        setScrolling.cancel()
      } else {
        setScrolling(false)
      }
    }

    window.addEventListener('scroll', handleScrollEvent, false)

    return () => window.removeEventListener('scroll', handleScrollEvent, false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return isScrolling
}
